import React from "react"
import { Wave } from "react-animated-text"
import styles from "./Team.module.css"
import Mediallustration from "./Mediallustration"

const DesignTeam = () => {
  const [width, setWidth] = React.useState()
  React.useEffect(() => {
    setWidth(window.innerWidth)
  }, [])
  const updateDimensions = () => {
    setWidth(window.innerWidth)
  }
  const updateWidth = () => {
    setWidth(window.innerWidth)
  }

  React.useEffect(() => {
    window.addEventListener("resize", updateWidth)
    return () => {
      window.removeEventListener("resize", updateDimensions)
    }
  }, [width])
  const text = `Media Management Team`
  return (
    <div className={styles.container}>
      {/* <div className={styles.containerContentTeam} ref={container}></div> */}
      {width > 768 && <Mediallustration />}
      <div className={styles.subContainer}>
        <span className={styles.heading}>
          <Wave text={text} effect="stretch" iterations={1} effectChange={2} />
        </span>
        {width <= 768 && <Mediallustration />}

        <span className={styles.para}>
          {" "}
          This team will be responsible for managing the club publicity issues
          and helping the club's privileges and benefits get reached to numerous
          minds via social media platforms. The people who join here will get
          broad exposure to the marketing strategies and simultaneously become
          the Club's face even.&nbsp;
          <a href="/team/media_team" rel="noreferrer">
            Know More...
          </a>
        </span>
      </div>
    </div>
  )
}

export default DesignTeam
